<script>
import Logo from '@/assets/logo/CardsTextLogoVertical-medium.svg';

export default {
  name: 'Footer',

  components: {
    Logo,
  },

  methods: {
    getApp() {
      const { $router, $store } = this;
      $router.push({ name: 'Install' });
      $store.dispatch('analytics/getAppClick', 'Footer');
    },
  },
};
</script>

<template>
  <div class="footer">
    <Logo class="logo" />

    <div class="footer-links">
      <a @click="getApp">
        Get app
      </a>

      <a @click="$router.push({ name: 'PrivacyPolicy' })">
        Privacy Policy
      </a>

      <a @click="$router.push({ name: 'TermsOfService' })">
        Terms of Service
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  padding: 1rem;
  box-sizing: border-box;
  background-color: $blue-light;

  .logo {
    width: auto;
    max-width: auto;
    height: 120px;
    margin-bottom: 1rem;
    box-sizing: border-box;
    fill: $blue-medium;
    filter: $white-drop-shadow;
  }

  .footer-links {
    display: flex;
    justify-content: center;

    a {
      margin: 0.5rem 1rem;
    }

    .sm & {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
